import { CartProvider } from '../../hooks/useCart';
import { WishlistProvider } from '../../hooks/useWishlist';

export const AppProviders = ({ children }) => {
  return (
    <CartProvider>
      <WishlistProvider>
        {children}
      </WishlistProvider>
    </CartProvider>
  );
};